<template>
  <div>
    <AppWithLoading
      :fetch="fetch"
      v-slot:default="{loader}"
    >
      <template v-if="vacancies.length">
        <div class="vacancy-list-filter-list">
          <div
            v-for="vacancy in vacancies"
            :key="vacancy.id"
            class="vacancy-list-filter-list__item"
          >
            <VCheckbox
              v-model="selected"
              :value="vacancy.id"
              hide-details
            >
              <template #label>
                <div class="vacancy-list-filter-list__item-wrap">
                  <div class="vacancy-list-filter-list__name">
                    {{ vacancy.title }}
                  </div>
                  <div class="vacancy-list-filter-list__description">
                    <span v-if="vacancy.address">
                      {{ vacancy.address.city }}
                    </span>
                  </div>
                  <div class="vacancy-list-filter-list__date" v-if="vacancy.publishedTill">
                    <div class="vacancy-list-filter-list__date-icon" v-if="vacancy.publishedTillLessThanMonth">
                      <img src="../../assets/img/qr/alert.svg" alt="">
                    </div>
                    <span :style="`color:${vacancy.publishedTillLessThanMonth ? 'red' : 'black'}`">{{ $t('publishedTill', { date: getDateText(vacancy.publishedTill)}) }}</span>
                  </div>
                </div>
              </template>
            </VCheckbox>
          </div>
        </div>
      </template>
      <template v-else>
        <VAlert color="error" outlined>
          {{ $t('empty') }}
        </VAlert>
      </template>
      <template v-if="metaData && metaData.lastPage > 1">
        <VPagination
          :value="currentPage"
          @input="loader(()=> loadPage($event))"
          :length="metaData.lastPage"
        />
      </template>
    </AppWithLoading>
  </div>
</template>

<script>
import {
  computed, ref, toRefs,
} from '@vue/composition-api';
import AppWithLoading from '@/components/AppWithLoading';
import useVacanciesList from '@/compositions/useVacanciesList';
import moment from 'moment';
import { useI18n } from 'vue-i18n-composable';

export default {
  name: 'VacanciesListDetailFilterList',
  components: { AppWithLoading },
  props: {
    value: {
      type: Array,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { value } = toRefs(props);
    const { vacancies, fetchVacancies, metaDataVacancies } = useVacanciesList();
    const { locale } = useI18n();
    const selected = computed({
      get() {
        return value.value;
      },
      set(val) {
        emit('input', val);
      },
    });
    const currentPage = ref(1);

    async function fetch(page = 1) {
      await fetchVacancies({ ...value.value, perPage: 20, page });
    }

    async function loadPage(page) {
      await fetch(page);
      currentPage.value = page;
    }

    function getDateText(date) {
      if (locale.value.toLowerCase() === 'ru') {
        return moment(date)
          .locale(locale.value.toLowerCase()).format('DD.MM.YYYY');
      }

      return moment(date)
        .locale(locale.value.toLowerCase()).format('MM/DD/YYYY');
    }

    return {
      vacancies,
      selected,
      fetch,
      loadPage,
      currentPage,
      getDateText,
      metaData: metaDataVacancies,
    };
  },
};
</script>

<style lang="scss" scoped>
.vacancy-list-filter-list {
  padding: 0.3125rem 0 0 1.875rem;
  margin: -0.25rem 0 1.25rem;
  &__item {
    line-height: 1.25;
    color: #212121;
    border-bottom: 1px solid #EEEEEE;
    padding: 0.46875rem 0 0.71875rem;
    &:first-child {
      border-top: 1px solid #EEEEEE;
    }
  }
  &__item-wrap {
    align-self: flex-start;
  }
  &__name {
    margin-bottom: 0.3125rem;
  }
  &__description {
    font-size: 0.75rem;
    line-height: 1.66
  }
  &__date {
    display: flex;
    height: 1.125rem;
    align-items: flex-end;
    font-size: 0.875rem;
    line-height: 1.1;
    padding-top: 0.125rem;
  }
  &__date-icon {
    width: 1.125rem;
    height: 1.125rem;
    margin-right: 0.25rem;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
}
@media #{map-get($display-breakpoints, 'xs-only')} {
  .vacancy-list-filter-list {
    padding-left: 0;

    &__item {
      padding: 0.375rem 0 0.625rem;
    }
    &__name {
      font-size: 0.875rem;
      margin-bottom: 0.1875rem;
    }
  }
}
</style>

<style lang="scss">
.vacancy-list-filter-list {
  .v-input__slot {
    align-items: flex-start;
  }
}
</style>

<i18n lang="yml" locale="ru">
empty: У вас нет активных вакансий
publishedTill: 'Опубликовано до: {date}'

</i18n>
<i18n lang="yml" locale="en">
empty: You have no active jobs
publishedTill: 'Published till: {date}'
</i18n>
